import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const routes = [
  {
    path: '/',
    name: 'Employees',
    component: () => import('../views/employee/EmployeesPage.vue'),
    meta: { layout: 'main', auth: true, notCourier: true },
  },
  {
    path: '/employee/:id',
    name: 'Employee',
    component: () => import('../views/employee/EmployeePage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/employee/new-employee',
    name: 'New Employee',
    component: () => import('../views/employee/EmployeeCreate.vue'),
    meta: {
      layout: 'main',
      auth: true,
      notAreaManager: true,
      notCourier: true,
    },
  },
  {
    path: '/employee/edit-profile/:id',
    name: 'Edit profile',
    component: () => import('../views/employee/EditProfile.vue'),
    meta: {
      layout: 'main',
      auth: true,
      notAreaManager: true,
      notCourier: true,
    },
  },
  {
    path: '/work-logs',
    name: 'Work Logs',
    component: () => import('../views/worklogs/WorkLogsPage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/routes',
    name: 'Routes',
    component: () => import('../views/route/RoutesPage.vue'),
    meta: {
      layout: 'main',
      auth: true,
      notAreaManager: true,
      notCourier: true,
    },
  },
  {
    path: '/routes/create',
    name: 'Route Create',
    component: () => import('../views/route/CreateRoute.vue'),
    meta: {
      layout: 'main',
      auth: true,
      notAreaManager: true,
      notCourier: true,
    },
  },
  {
    path: '/routes/:id',
    name: 'Route Edit',
    component: () => import('../components/route/EditRoute.vue'),
    meta: {
      layout: 'main',
      auth: true,
      notAreaManager: true,
      notCourier: true,
    },
  },
  {
    path: '/leaves',
    name: 'Leaves',
    components: {
      default: () => import('../views/leaves/LeavesPage.vue'),
      extra: () => import('../views/leaves/HolidaysPage.vue'),
    },
    meta: { layout: 'main', auth: true, notCourier: true },
  },
  {
    path: '/payments',
    name: 'Payments',
    component: () => import('../views/payments/PaymentsPage.vue'),
    meta: { layout: 'main', auth: true, notCourier: true },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/UsersPage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/complaints',
    name: 'Complaints',
    component: () => import('../views/ComplaintsPage.vue'),
    meta: { layout: 'main', auth: true, notCourier: true },
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: () => import('../views/auth/SignIn.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/forgot_password',
    name: 'Forgot Password',
    component: () => import('../views/auth/ForgotPassword.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/check_email',
    name: 'Check Email',
    component: () => import('../views/auth/CheckEmail.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/new_password',
    name: 'New Password',
    component: () => import('../views/auth/NewPassword.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/accept_invite',
    name: 'Accept invite',
    component: () => import('../views/auth/NewPassword.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/success_reset',
    name: 'Success Reset',
    component: () => import('../views/auth/SuccessReset.vue'),
    meta: { layout: 'auth', auth: false },
  },
  {
    path: '/success_invite',
    name: 'Success Invite',
    component: () => import('../views/auth/SuccessInvite.vue'),
    meta: { layout: 'auth', auth: false },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  const storeAuth = useAuthStore()
  const requireAuth = to.meta.auth

  if (requireAuth) {
    if (storeAuth.isAuthenticated) {
      if (storeAuth.isAdmin) {
        return next()
      }

      if (to.meta.notCourier && storeAuth.isCourier) {
        return next(`/employee/${storeAuth.user.id}`)
      }

      if (to.meta.notAreaManager && storeAuth.isAreaManager) {
        return next('/')
      }

      return next()
    } else {
      return next('/sign-in')
    }
  }

  next()
})

export default router
